import { Button, Header, LoadingOverlay } from '@astro-ui/components'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'
import {
  reset,
  setCreateSO,
  fetchGetSOProduct,
  fetchPutSupplyOrderDetail,
  fetchPostSupplyOrderDetail,
} from 'features/SupplyOrder/redux/outboundSOAddProduct'
import { toastSuccess } from 'utils/toast'
import { PutSupplyOrderDetailRequestType } from 'features/SupplyOrder/services/outboundSO'
import Table from './Table'

const OutboundSOAddProduct = () => {
  const history = useHistory()

  const dispatch = useAppDispatch()

  const { isLoading, selectedItems, createSO } = useAppSelector(
    (state) => state.outboundSOAddProduct,
    shallowEqual,
  )

  const isSubmitDisabled = useAppSelector((state) => {
    const { outboundSOAddProductDirect } = state
    const products = outboundSOAddProductDirect.data
    const { checkedIds } = outboundSOAddProductDirect

    if (checkedIds.length === 0) return true

    return checkedIds.some((id) => {
      const qty = Number(selectedItems[id]?.productRequestQuantity ?? 0)

      const product = products.find((p) => p.productUniqueKey === id)
      if (!product) return false

      return qty <= 0 || qty > product.productStock
    })
  })

  const productSelected = useAppSelector(
    (state) => state.outboundSOAddProduct.checkedIds,
    shallowEqual,
  )

  const generatePayload = () => {
    const isSOReturnType = createSO?.soType.toLowerCase() === 'return'

    const supplyOrderRequest: PutSupplyOrderDetailRequestType['supplyOrderRequest'] = {
      locationDestinationId: isSOReturnType
        ? createSO.poReff?.vendorId || 0
        : createSO.destination?.location_id || 0,
      locationOriginId: createSO.origin?.location_id || 0,
      remarks: createSO?.remarks?.code || '-',
      requestBy: createSO?.email || '',
      shippingInstructions: createSO?.shippingInstructions || '',
      soDate: createSO.soDate ? new Date(createSO.soDate).getTime() : 0,
      soReff: isSOReturnType ? createSO.poReff?.poNumber || null : createSO.soReff || null,
      soType: createSO.soType,
      createdBy: createSO?.createdBy,
      status: createSO?.status,
    }
    const supplyOrderItemRequest = Object.values(selectedItems)

    return { supplyOrderRequest, supplyOrderItemRequest }
  }

  const handleSubmit = () => {
    const { supplyOrderRequest, supplyOrderItemRequest } = generatePayload()

    if (createSO?.supplyOrderId) {
      dispatch(
        fetchPutSupplyOrderDetail({
          supplyOrderId: createSO.supplyOrderId,
          payload: {
            supplyOrderRequest,
            supplyOrderItemRequest,
          },
          onSuccess: async () => {
            localStorage.removeItem('createSOState')
            toastSuccess('Produk berhasil diperbarui')
            history.goBack()
          },
        }),
      )
    } else {
      dispatch(
        fetchPostSupplyOrderDetail({
          payload: {
            ...supplyOrderRequest,
            supplyOrderItems: supplyOrderItemRequest,
          },
          onSuccess: (supplyOrderId) => {
            localStorage.removeItem('createSOState')
            toastSuccess('Produk berhasil ditambahkan')
            history.replace(`/dashboard/outbound-so/edit/${supplyOrderId}`)
          },
        }),
      )
    }
  }

  useEffect(() => {
    const createSOState = JSON.parse(localStorage.getItem('createSOState') as string)

    dispatch(setCreateSO(createSOState))
    dispatch(
      fetchGetSOProduct({
        locationId: createSOState?.origin.location_id,
        params: {
          pageIndex: 0,
          pageSize: 20,
          soType: createSOState?.soType,
          purchaseOrderId: createSOState?.poReff?.poId,
        },
      }),
    )

    return () => {
      dispatch(reset())
    }
  }, [dispatch])

  return (
    <>
      <LoadingOverlay isLoading={isLoading} />
      <Header
        title="Tambah Produk"
        subtitle="Pilih produk dan isi jumlah kuantiti yang mau ditambahkan ke Supply Order"
        withBackButton
        handleGoBack={() => history.goBack()}
        RightComponent={
          <Button sx={{ width: '164px' }} disabled={isSubmitDisabled} onClick={handleSubmit}>
            Tambah {productSelected.length > 0 ? productSelected.length : ''} Produk
          </Button>
        }
      />
      <Table />
    </>
  )
}

export default OutboundSOAddProduct
